var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMpoweredCoinTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F6D738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 22.185C17.6244 22.185 22.1841 17.6254 22.1841 12.0007C22.1841 6.37608 17.6244 1.81641 11.9997 1.81641C6.3751 1.81641 1.81543 6.37608 1.81543 12.0007C1.81543 17.6254 6.3751 22.185 11.9997 22.185Z",
    fill: "#F3CC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60002 12.9311C3.60002 7.96591 7.62484 3.94109 12.59 3.94109C15.4923 3.94109 18.0726 5.31646 19.7163 7.45076C18.1641 4.75596 15.2542 2.94141 11.9206 2.94141C6.95548 2.94141 2.93066 6.96623 2.93066 11.9314C2.93066 13.9943 3.6261 15.8946 4.79435 17.4117C4.03504 16.0927 3.60002 14.5623 3.60002 12.9311Z",
    fill: "#F7DB5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 12.8851L8.99902 10.727V7.2002L11.999 9.35825V12.8851Z",
    fill: "#D9AC29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 17.1999L6.00098 12.8848V9.40479L11.9989 13.7199V17.1999Z",
    fill: "#D9AC29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1999L17.999 12.8848V9.40479L12 13.7199V17.1999Z",
    fill: "#EDBD31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8851L15 10.727V7.2002L12 9.35825V12.8851Z",
    fill: "#EDBD31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.8851L15 10.727V7.2002L18 9.35825V12.8851Z",
    fill: "#D9AC29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.8851L9 10.727V7.2002L6 9.35825V12.8851Z",
    fill: "#EDBD31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpoweredCoinTransparent);
export default __webpack_public_path__ + "static/media/mpoweredCoinTransparent.c7cd9b15b0c7432a876db25dab0c2ee0.svg";
export { ForwardRef as ReactComponent };